/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const HandleBar = () => {
  const handleBarStyles = [
    'sui-w-[10%]',
    'sui-h-[6px]',
    'sui-bg-strong',
    'sui-rounded-full',
    'sui-left-[15px]'
  ].join(' ');
  return <div className={handleBarStyles} />;
};

const SwipeableDrawer = (props) => {

  const {
    fixed
  } = props;

  const classes = classNames(
    'sui-bg-primary sui-shadow-lg sui-overflow-y-scroll sui-z-[1300px] sui-outline-none sui-max-w-full sui-w-full sui-rounded-t-lg',
    'portrait:sui-fixed portrait:sui-bottom-0 portrait:sui-h-auto portrait:sui-min-h-[25%] portrait:sui-max-h-[88%]',
    'landscape:sui-col-span-6 landscape:sui-col-end-13',
    {
      'sui-max-h-[50%] sui-min-h-[50%] sui-h-[50%]': fixed
    }
  );

  const handleBarDivStyles = classNames('landscape:sui-hidden sui-m-2 sui-flex sui-items-center sui-justify-center');

  const { children } = props;

  return (
    <div className={classes}>
      <div className="landscape:sui-hidden sui-m-2">
        {/* <HandleBar /> */}
      </div>
      {children}
    </div>
  );
};

SwipeableDrawer.displayName = 'SwipeableDrawer';

SwipeableDrawer.propTypes = {
  children: PropTypes.node,
  fixed: PropTypes.bool,
};

SwipeableDrawer.defaultProps = {
  fixed: false
};

export { SwipeableDrawer };